import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";
import PersonIcon from "@material-ui/icons/Person";
import { useState } from "react";
import ShurikenProgress from "../../../Animations/ShurikenProgress";
import { UploadCameraButton } from "../../UserAvatar/UploadCameraButton";
import { OtherUser } from "../../types";

export function AlternativeAvatar({
    targetUser,
    isMyself,
}: {
    targetUser: OtherUser;
    isMyself: boolean;
}) {
    const c = useAlternativeAvatarStyles();
    const [submitting, setSubmitting] = useState(false);

    return (
        <div className={c.container}>
            <Avatar className={c.avatar}>
                {submitting ? (
                    <ShurikenProgress
                        style={{ width: 100, height: 100 }}
                        size={60}
                    />
                ) : (
                    <PersonIcon className={c.personIcon} />
                )}
            </Avatar>

            {isMyself && targetUser.sul < 3 && (
                <UploadCameraButton
                    submitting={submitting}
                    setSubmitting={setSubmitting}
                    userId={targetUser.userId}
                    size={70}
                    style={{
                        position: "absolute",
                        right: 0,
                        bottom: 0,
                        margin: 0,
                    }}
                />
            )}
        </div>
    );
}
const useAlternativeAvatarStyles = makeStyles(({ palette }) => ({
    container: {
        width: "100%",
        maxWidth: 300,
        display: "flex",
        justifyContent: "center",
        position: "relative",
    },
    avatar: {
        width: "100%",
        maxWidth: 250,
        height: 250,
    },
    personIcon: { width: 200, height: 200 },
    label: { position: "absolute", right: -7, bottom: -5, margin: 0 },
    cameraButton: {
        borderRadius: "50%",
        maxWidth: 30,
        maxHeight: 30,
        minWidth: 30,
        minHeight: 30,
        backgroundColor: palette.grey[800],
        color: "white",
        transition: "all 200ms",
        "&:hover": {
            backgroundColor: palette.grey[600],
        },
        transform: "scale(0.8)",
    },
    cameraIcon: { width: 20, height: 20 },
    input: { display: "none" },
}));
